import { get } from '../index';

export const getCompanyUsersAndProjects = idCompany => {
  return get(`/projects-company/${idCompany}`);
};
